import { Map, List, fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import ProfileHelper from 'helpers/profile'
import { RESET_STORE } from 'constants/index'

// constants
export const USER_FETCH_DATA = 'user/FETCH_DATA'
export const USER_FETCH_TABLE_DATA = 'user/FETCH_TABLE_DATA'
export const USER_SET_TABLE_DATA = 'user/SET_TABLE_DATA'
export const USER_CHANGE = 'user/CHANGE'
export const USER_DELETE = 'user/DELETE'
export const USER_DELETE_OWN_ACCOUNT = 'user/USER_DELETE_OWN_ACCOUNT'
export const USER_DISPLAY_TABLE = 'user/DISPLAY_TABLE'
export const USER_CLEAR_STATE = 'user/CLEAR_STATE'
export const USER_CLEAR_STATE_LIST = 'user/CLEAR_STATE_LIST'
export const USER_CLEAR_STATE_FORM = 'user/CLEAR_STATE_FORM'
export const USER_REDIRECT = 'user/REDIRECT'
export const USER_SET_PASSWORD = 'user/SET_PASSWORD'
export const USER_SET_LOADING = 'user/SET_LOADING'

export const FETCH_USER_FORM_DATA = 'user/FETCH_USER_FORM_DATA'
export const [FETCH_USER_FORM_DATA_SUCCESS, FETCH_USER_FORM_DATA_FAILURE] = [
  `${FETCH_USER_FORM_DATA}_SUCCESS`,
  `${FETCH_USER_FORM_DATA}_FAILURE`,
]

export const USER_INVITATION = 'user/INVITATION'
export const [USER_INVITATION_SUCCESS, USER_INVITATION_FAILURE] = [
  `${USER_INVITATION}_SUCCESS`,
  `${USER_INVITATION}_FAILURE`,
]

// actions
export const userFetchTableData = ActionHelper.createActionObj(
  USER_FETCH_TABLE_DATA,
)
export const userFetchFormData = ActionHelper.createActionObj(
  FETCH_USER_FORM_DATA,
)
export const userClearState = ActionHelper.createActionObj(USER_CLEAR_STATE)
export const userClearStateList = ActionHelper.createActionObj(
  USER_CLEAR_STATE_LIST,
)
export const userClearStateForm = ActionHelper.createActionObj(
  USER_CLEAR_STATE_FORM,
)
export const userChange = ActionHelper.createActionObj(USER_CHANGE)
export const userDelete = ActionHelper.createActionObj(USER_DELETE)
export const userDeleteOwnAccount = ActionHelper.createActionObj(
  USER_DELETE_OWN_ACCOUNT,
)
export const sendInvitation = ActionHelper.createActionObj(USER_INVITATION)
export const setPassword = ActionHelper.createActionObj(USER_SET_PASSWORD)

// state
const initialState = fromJS({
  loading: false,
  formDataLoading: false,
  formData: {
    userGroups: [],
    roles: {},
    user: null,
    licensees: [],
  },
  tableData: {
    data: [],
    count: 0,
  },
  listData: [],
  status: false,
})

// reducers
const user = handleActions(
  {
    [USER_SET_LOADING]: (state, action) => state.set('loading', action.payload),
    [USER_SET_TABLE_DATA]: (state, action) =>
      state.set('tableData', Map(action.tableData)),
    [FETCH_USER_FORM_DATA]: state => state.set('formDataLoading', true),
    [FETCH_USER_FORM_DATA_SUCCESS]: (state, action) =>
      state.set('formDataLoading', false).set('formData', Map(action.formData)),
    [FETCH_USER_FORM_DATA_FAILURE]: state =>
      state.set('formDataLoading', false),
    [USER_INVITATION_SUCCESS]: state => state.set('status', true),
    [USER_DISPLAY_TABLE]: (state, action) =>
      state.set('loading', false).set('listData', List(action.listData)),
    [USER_DELETE]: state => state.set('loading', true),
    [USER_CLEAR_STATE]: () => initialState,
    [USER_CLEAR_STATE_FORM]: state =>
      state.set('formData', initialState.get('formData')),
    [USER_CLEAR_STATE_LIST]: state =>
      state.set('tableData', initialState.get('tableData')),
    [RESET_STORE]: () => {
      ProfileHelper.removeToken()

      return initialState
    },
  },
  initialState,
)

export default user
